export const ReportFilterValues = Object.freeze({
    Next_7_Days: 1,
    Next_14_Days: 2,
    Last_7_Days: 3,
    Last_14_Days: 4,
    Month: 5,
    Custom: 6,
  })
  export const ReportFilterText = Object.freeze({
    Next_7_Days: "Next 7 Days",
    Next_14_Days: "Next 14 Days",
    Last_7_Days: "Last 7 Days",
    Last_14_Days: "Last 14 Days",
    Month: "Month To Date",
    Custom: "Custom",
  })

  export const SoldTradeRoundFilterValues = Object.freeze({
    Next_To_NextWeek: 1,
    Next_Week: 2,
    Current_Week: 3,
    Last_Week: 4,
    Last_To_LastWeek: 5,
    Custom_Daily: 6,
    Custom_Weekly: 7
  })
  export const SoldTradeRoundFilterText = Object.freeze({
    Next_To_NextWeek: "Next To Next Week",
    Next_Week: "Next Week",
    Current_Week: "Current Week",
    Last_Week: "Last Week",
    Last_To_LastWeek: "Last To Last Week",
    Custom_Daily: "Custom Daily",
    Custom_Weekly: "Custom Weekly"
  })
  export const TradeReportType = Object.freeze({
    SoldVsUnsoldTradeRoundReport: 1,
    SoldTradeRoundReport: 2,
    BankingAndReAllocationReport: 3,
  })